import { defineComponent as _defineComponent } from 'vue'
import { renderSlot as _renderSlot, withCtx as _withCtx, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, withKeys as _withKeys, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, vShow as _vShow, withDirectives as _withDirectives, unref as _unref } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "table-custom-large"
}
const _hoisted_2 = { class: "list-group" }
const _hoisted_3 = {
  key: 1,
  class: "table-custom-large"
}
const _hoisted_4 = { class: "empty" }

import { computed, ref, watch } from 'vue'
import { useI18n } from 'vue-i18n'
import SvgDisplay from '../atoms/SvgDisplay.vue'
import TableCellData from '@/design-system/atoms/TableCellData.vue'
import TableCellHeading from '@/design-system/atoms/TableCellHeading.vue'
import TableRow from '@/design-system/atoms/TableRow.vue'
import TooltipStandard from '@/design-system/atoms/TooltipStandard.vue'
import { Direction } from '@/services/attachments.service'

export type TableItem = {
  id: string
  name: string
  entityId?: string
  fileType?: string
  createdDate?: string
  sorting?: string
  entityType: string
  actStatus?: string
  actType?: string
}

type Props = {
  fields: Array<any>
  hasArchiveButton?: boolean
  hasCreateButton?: boolean
  hasDeleteButton?: boolean
  hasDownloadButton?: boolean
  hasEditButton?: boolean
  hasMenu?: boolean
  hasSorting?: boolean
  items: TableItem[]
  itemType: string
  selectedIds: string[]
  resetSorting?: boolean
}
type Emits = {
  (e: 'archiveItem'): void
  (e: 'deleteItem'): void
  (e: 'downloadItem'): void
  (e: 'editItem', item: TableItem): void
  (e: 'onClickedRow', item: TableItem, withinCheckbox: boolean): void
  (e: 'sortBy', key: string, value: Direction): void
}

export default /*@__PURE__*/_defineComponent({
  __name: 'TableCustomLarge',
  props: {
    fields: {},
    hasArchiveButton: { type: Boolean },
    hasCreateButton: { type: Boolean },
    hasDeleteButton: { type: Boolean },
    hasDownloadButton: { type: Boolean },
    hasEditButton: { type: Boolean },
    hasMenu: { type: Boolean },
    hasSorting: { type: Boolean },
    items: {},
    itemType: {},
    selectedIds: {},
    resetSorting: { type: Boolean }
  },
  emits: ["archiveItem", "deleteItem", "downloadItem", "editItem", "onClickedRow", "sortBy"],
  setup(__props: any, { emit: __emit }) {

const props = __props
const emits = __emit
const { t } = useI18n()
const hoveredTitle = ref<string>('')
const lastMousePosition = ref([0, 0])
const showTooltip = ref(false)
const sortByDirection = ref<Direction>('asc')
const selectedSortKey = ref<string>('name') // name or uploaded
const trackedMouseEvent = ref<Object>()

const fields = computed(() => {
  return props.fields
})
function handleRowClick(event: Event, item: TableItem) {
  // @ts-ignore
  const withinCheckbox = event.target?.previousSibling?.type === 'checkbox'
  emits('onClickedRow', item, withinCheckbox)
}
function handleSorting(key: string) {
  sortByDirection.value = sortByDirection.value === 'asc' ? 'desc' : 'asc'
  if (key !== selectedSortKey.value) {
    sortByDirection.value = 'asc'
  }
  selectedSortKey.value = key
  emits('sortBy', key, sortByDirection.value)
}

function trackPointer(event, title: string) {
  hoveredTitle.value = title
  const rect = event.currentTarget.getBoundingClientRect()
  if (event) {
    if (
      lastMousePosition.value[0] === event.clientX &&
      lastMousePosition.value[1] === event.clientY
    )
      return
    lastMousePosition.value = [event.clientX, event.clientY]
    trackedMouseEvent.value = {
      x: rect.left + rect.width / 2,
      y: rect.bottom + rect.height / 2
    }
    const targetEl = event.target as HTMLElement
    if (targetEl.firstElementChild) {
      showTooltip.value =
        targetEl.firstElementChild.clientWidth < targetEl.firstElementChild.scrollWidth
    }
  }
}

watch(
  () => props.resetSorting,
  (newValue) => {
    if (newValue === true) {
      sortByDirection.value = 'asc'
    }
  }
)

return (_ctx: any,_cache: any) => {
  return (_ctx.items?.length && fields.value?.length)
    ? (_openBlock(), _createElementBlock("table", _hoisted_1, [
        _createElementVNode("thead", null, [
          _createVNode(TableCellHeading, null, {
            default: _withCtx(() => [
              _renderSlot(_ctx.$slots, "checkbox-heading")
            ]),
            _: 3
          }),
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(fields.value, (field) => {
            return (_openBlock(), _createBlock(TableCellHeading, {
              key: field.key,
              class: _normalizeClass({ sort: field.sortable }),
              tabindex: field.sortable ? 0 : -1,
              onClick: ($event: any) => (handleSorting(field.key)),
              onKeydown: [
                _withKeys(($event: any) => (handleSorting(field.key)), ["enter"]),
                _withKeys(($event: any) => (handleSorting(field.key)), ["space"])
              ]
            }, {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString(field.name) + " ", 1),
                (field.sortable && field.key === selectedSortKey.value && sortByDirection.value === 'asc')
                  ? (_openBlock(), _createBlock(SvgDisplay, {
                      key: 0,
                      src: "Icon-Chevron-Down-Small"
                    }))
                  : _createCommentVNode("", true),
                (field.sortable && field.key === selectedSortKey.value && sortByDirection.value === 'desc')
                  ? (_openBlock(), _createBlock(SvgDisplay, {
                      key: 1,
                      src: "Icon-Chevron-Up-Small"
                    }))
                  : _createCommentVNode("", true),
                (field.sortable && field.key !== selectedSortKey.value)
                  ? (_openBlock(), _createBlock(SvgDisplay, {
                      key: 2,
                      src: "Icon-chevrons-up-down"
                    }))
                  : _createCommentVNode("", true)
              ]),
              _: 2
            }, 1032, ["class", "tabindex", "onClick", "onKeydown"]))
          }), 128))
        ]),
        _createElementVNode("tbody", null, [
          _createElementVNode("div", _hoisted_2, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.items, (item) => {
              return (_openBlock(), _createBlock(TableRow, {
                key: item.id,
                class: _normalizeClass({
            'has-sorting': _ctx.hasSorting,
            selected: _ctx.selectedIds.find((attachmentId) => attachmentId === item.id)
          }),
                onOnClicked: (event) => handleRowClick(event, item)
              }, {
                default: _withCtx(() => [
                  _createVNode(TableCellData, null, {
                    default: _withCtx(() => [
                      _renderSlot(_ctx.$slots, "checkbox-data", { item: item })
                    ]),
                    _: 2
                  }, 1024),
                  _createVNode(TableCellData, {
                    onMouseleave: _cache[0] || (_cache[0] = ($event: any) => (showTooltip.value = false)),
                    onMouseenter: (e) => trackPointer(e, item.name)
                  }, {
                    default: _withCtx(() => [
                      _createElementVNode("p", null, _toDisplayString(item.name), 1),
                      _withDirectives(_createVNode(TooltipStandard, {
                        arrowPosition: "top-center",
                        class: "tooltip",
                        pointerEvent: trackedMouseEvent.value,
                        text: hoveredTitle.value
                      }, null, 8, ["pointerEvent", "text"]), [
                        [_vShow, showTooltip.value]
                      ])
                    ]),
                    _: 2
                  }, 1032, ["onMouseenter"]),
                  _createVNode(TableCellData, {
                    onMouseleave: _cache[1] || (_cache[1] = ($event: any) => (showTooltip.value = false)),
                    onMouseenter: (e) => trackPointer(e, item.actType ?? '')
                  }, {
                    default: _withCtx(() => [
                      _createElementVNode("p", null, _toDisplayString(item.actType ?? ''), 1),
                      _withDirectives(_createVNode(TooltipStandard, {
                        arrowPosition: "top-center",
                        class: "tooltip",
                        pointerEvent: trackedMouseEvent.value,
                        text: hoveredTitle.value
                      }, null, 8, ["pointerEvent", "text"]), [
                        [_vShow, showTooltip.value]
                      ])
                    ]),
                    _: 2
                  }, 1032, ["onMouseenter"]),
                  _createVNode(TableCellData, {
                    onMouseleave: _cache[2] || (_cache[2] = ($event: any) => (showTooltip.value = false)),
                    onMouseenter: (e) => trackPointer(e, item.actStatus ?? '')
                  }, {
                    default: _withCtx(() => [
                      _createElementVNode("p", null, _toDisplayString(item.actStatus ?? ''), 1),
                      _withDirectives(_createVNode(TooltipStandard, {
                        arrowPosition: "top-center",
                        class: "tooltip",
                        pointerEvent: trackedMouseEvent.value,
                        text: hoveredTitle.value
                      }, null, 8, ["pointerEvent", "text"]), [
                        [_vShow, showTooltip.value]
                      ])
                    ]),
                    _: 2
                  }, 1032, ["onMouseenter"]),
                  _createVNode(TableCellData, {
                    onMouseleave: _cache[3] || (_cache[3] = ($event: any) => (showTooltip.value = false)),
                    onMouseenter: (e) => trackPointer(e, item.name)
                  }, {
                    default: _withCtx(() => [
                      _createElementVNode("p", null, _toDisplayString(item.createdDate ? new Date(item.createdDate).toLocaleDateString() : ''), 1),
                      _withDirectives(_createVNode(TooltipStandard, {
                        arrowPosition: "top-center",
                        class: "tooltip",
                        pointerEvent: trackedMouseEvent.value,
                        text: hoveredTitle.value
                      }, null, 8, ["pointerEvent", "text"]), [
                        [_vShow, showTooltip.value]
                      ])
                    ]),
                    _: 2
                  }, 1032, ["onMouseenter"]),
                  _createVNode(TableCellData, null, {
                    default: _withCtx(() => [
                      _renderSlot(_ctx.$slots, "placement", { item: item })
                    ]),
                    _: 2
                  }, 1024)
                ]),
                _: 2
              }, 1032, ["class", "onOnClicked"]))
            }), 128))
          ])
        ])
      ]))
    : (_openBlock(), _createElementBlock("table", _hoisted_3, [
        _createElementVNode("thead", null, [
          _createVNode(TableCellHeading, null, {
            default: _withCtx(() => [
              _createTextVNode(_toDisplayString(0 + ' ' + _ctx.itemType.toLowerCase()), 1)
            ]),
            _: 1
          })
        ]),
        _createElementVNode("tbody", null, [
          _createElementVNode("div", _hoisted_4, [
            _createVNode(TableRow, null, {
              default: _withCtx(() => [
                _createVNode(TableCellData, null, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(_unref(t)('general__text__no') +
              ' ' +
              _ctx.itemType.toLowerCase() +
              ' ' +
              _unref(t)('general__text__available').toLowerCase()), 1)
                  ]),
                  _: 1
                })
              ]),
              _: 1
            })
          ])
        ])
      ]))
}
}

})